import { ReplicatorStatus } from "../../models/ReplicatorStatus";
import { ArcGisToken } from "../../models/ArcGisToken";
import { LOGOUT, SET_SYNC_STATUS, SET_ARCGIS_TOKEN, CLEAR_ARCGIS_TOKEN, AppControlActionTypes } from "./types";

export function setSyncStatus(newStatus: ReplicatorStatus): AppControlActionTypes {
    return {
        type: SET_SYNC_STATUS,
        newStatus,
    };
}

export function logOut(): AppControlActionTypes {
    return {
        type: LOGOUT,
    };
}

export function setArcGISToken(token: ArcGisToken): AppControlActionTypes {
    return {
        type: SET_ARCGIS_TOKEN,
        token,
    };
}

export function clearArcGISToken(): AppControlActionTypes {
    return {
        type: CLEAR_ARCGIS_TOKEN,
    };
}
